import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@ui/dialog";
import TranslatedText from "@components/items/display/TranslatedText";
import { SearchInput } from "./SearchInput";

const AddItemToPlaylistDialog = ({
  trigger,
  open,
  setOpen,
}: {
  trigger: React.ReactNode;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      {trigger}
      <DialogContent className="flex w-[500px] flex-col items-center justify-center gap-5 bg-white py-8 dark:border-none dark:bg-[#3C3B40]">
        <DialogHeader className="flex flex-col items-center justify-center gap-2">
          <DialogTitle>
            <TranslatedText
              text={`my-library.${"add items to your playlist"}`}
              className="dark:text-white"
            />
          </DialogTitle>
        </DialogHeader>
        <DialogDescription className="flex w-full items-center justify-center">
          <SearchInput setOpenAddItemDialog={setOpen} />
        </DialogDescription>
      </DialogContent>
    </Dialog>
  );
};

export default AddItemToPlaylistDialog;
